import React, { ReactElement, ReactNode, useEffect, useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface ProtectedRouteProps {
    children: ReactElement; // or ReactNode if you prefer
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(true);
    const navigate = useNavigate();

    const refreshSession = () => {
        // Update session start time to current time
        localStorage.setItem('sessionStartTime', new Date().toISOString());
    };

    useEffect(() => {
        const checkSession = () => {
            // const sessionData = sessionStorage.getItem('sessionData');
            // const sessionStartTime = sessionStorage.getItem('sessionStartTime');
            const sessionData = localStorage.getItem('sessionData');
            const sessionStartTime = localStorage.getItem('sessionStartTime');
            if (sessionData && sessionStartTime) {
                const sessionStart = new Date(sessionStartTime).getTime();
                const currentTime = new Date().getTime();
                const sessionDuration = currentTime - sessionStart;
                const maxSessionDuration = 120 * 60 * 1000; // 120 minutes in milliseconds

                if (sessionDuration < maxSessionDuration) {
                    setIsAuthenticated(true);
                    refreshSession();
                } else {
                    // sessionStorage.removeItem('sessionData');
                    // sessionStorage.removeItem('sessionStartTime');
                    localStorage.removeItem('sessionData');
                    localStorage.removeItem('sessionStartTime');
                    localStorage.removeItem('userData');
                    localStorage.removeItem('SessionKey');
                    localStorage.clear();
                    setIsAuthenticated(false);
                    navigate('/login')
                }
            } else {
                setIsAuthenticated(false);
                navigate('/login')
            }
            setLoading(false);
        };

        checkSession();
    }, []);

    if (loading) {
        return <div>Loading...</div>; // Optionally show a loading indicator
    }

    return isAuthenticated ? children : <Navigate to="/login" />;
};

export default ProtectedRoute;
